export default function creerObjetCaption (annonceId, diffuseurNomDeCode, content = '') {
  return {
    annonceId: annonceId,
    diffuseurNomDeCode: diffuseurNomDeCode,
    text: content
  }
}
